import Vue from "vue";

import * as dashboard from "@/consts/dashboard";
import * as survey from "@/consts/survey";
import * as interaction from "@/consts/interaction";
import * as dates from "@/consts/dates";
import * as globalization from "@/consts/globalization";
import * as general from "@/consts/general";
import * as metadata from "@/consts/metadata";
import * as integrations from "@/consts/integrations";
import * as zendesk from "@/consts/zendesk";
import * as widget from "@/consts/widget";
import * as segment from "@/consts/segment";
import * as loop from "@/consts/loop";
import * as jumpLogic from "@/consts/jumpLogic";
import * as errors from "@/consts/errors";
import * as template from "@/consts/template";
import * as user from "@/consts/user";

export const consts = {
  ...dashboard,
  ...survey,
  ...interaction,
  ...dates,
  ...globalization,
  ...general,
  ...metadata,
  ...integrations,
  ...zendesk,
  ...widget,
  ...segment,
  ...loop,
  ...jumpLogic,
  ...errors,
  ...template,
  ...user
};

Vue.prototype.$consts = consts;
